import React from "react";
import styled from "styled-components";
import PretendardText from "./../text/pretendardText";

const DividedBtn = (props) => {
  return (
    <StyledDividedBtn
      style={{
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <PretendardText
        style={{
          color: "#aaa",
          fontSize: "15px",
          fontWeight: "600",
          lineHeight: "24.75px",
          textAlign: "center",
        }}
      >
        {props.text1}
      </PretendardText>
      <span
        style={{
          width: 0,
          height: 16,
          borderRight: "1px solid var(--text3, rgba(181, 181, 181, 0.5))",
        }}
      />
      <PretendardText
        style={{
          color: "#009bde",
          fontSize: "16px",
          fontWeight: "700",
          lineHeight: "22.4px",
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={props.textHandler}
      >
        {props.text2}
      </PretendardText>
    </StyledDividedBtn>
  );
};

export default DividedBtn;

const StyledDividedBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 12px 20px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background-color: #272829;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;
